import {Component, OnInit} from '@angular/core';
import {TreeNode} from 'primeng/components/common/treenode';
import {TranslateService} from '@ngx-translate/core';
import {QFilterModel} from '../../../../models/qfilter.model';
import {Observable} from 'rxjs/Observable';
import {IndicatorOtherModel} from '../../../../models/indicator-box.model';
import {IndicatorsSearchToolbarModel} from '../../../../models/indicators-search-toolbar-model.model';
import {IndicatorsService} from '../../../../services/indicators/indicators.service';

@Component({
    selector: 'app-revenue-analysis-tree',
    templateUrl: './revenue-analysis-tree.component.html'
})

export class RevenueAnalysisTreeComponent implements OnInit {
    public data: QFilterModel;
    public base_tree: TreeNode[];
    public base_tree_legend: TreeNode[];
    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

    constructor(
        private translate: TranslateService,
        private indicatorService: IndicatorsService
    ) { }

    ngOnInit() {
        // this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });
    }

    expandTree(treeArray: Array<IndicatorOtherModel>, keyLevelName: string): TreeNode {
        const node: IndicatorOtherModel = treeArray.find(ind => ind.name === keyLevelName.trim());

        const tnode: TreeNode = {
            data: {
                current: node.current,
                previous: node.previous,
                percent: node.diffPercentage,
                uom: node.unitOfMeasure || '',
            },
            children: [],
            expanded: true,
            label: node.description.replace('.description', ''),
            type: 'node'
        };

        node.other.split(',').forEach(child => {
            if (child.trim() !== 'none') {
                tnode.children.push(this.expandTree(treeArray, child))
            }
        });

        return tnode;
    }

    searchValue(data: QFilterModel) {
        this.data = data;
        this.translate.get([
            'common.previous',
            'common.current',
            'common.difference',
            'common.legend'
        ]).subscribe(t => {

            this.indicatorService.indicatorCalculationOther('stores.Q017', this.data).switchMap((res) => {
                const legenda: TreeNode = {
                    data: {
                        current: t['common.current'],
                        previous: t['common.previous'],
                        percent: t['common.difference'],
                        type: 'legend',
                    },
                    children: [],
                    expanded: true,
                    label: t['common.legend'],
                    type: 'node'
                };

                this.base_tree = [this.expandTree(res, 'fatturato')];
                return Observable.of(legenda);
            }).subscribe(res => {
                this.base_tree_legend = [res];
            });

        });
    }

    public resetData() {
        this.data = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/tree/revenue-analysis-tree.component.ts